import BaseModelAPI from '../BaseModelAPI';

export default class BillOfMaterial extends BaseModelAPI {
	static entity = 'billofmaterial';
	static entityName = 'billofmaterial';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.partNumberId = '';
			this.partNumber = {};
			this.partName = '';
			this.customer = '';
			this.partClassification = '';
			this.billOfMaterialDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}